import reducer from "./reducers";

import * as serviceAction from "./actions";

export { serviceAction };

export default reducer;
